/** Dashboard glass aesthetic — canonical tokens for all primary views. */
export const ACCENT = "#D4AF37";

export const deskGlass = {
  container: {
    position: "relative",
    height: "calc(100vh - 64px)",
    width: "100%",
    color: "#fff",
    fontFamily: "'Inter', system-ui, sans-serif",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  page: {
    position: "relative",
    width: "100%",
    color: "#fff",
    fontFamily: "'Inter', system-ui, sans-serif",
    minHeight: "100%",
  },
  swiper: {
    display: "flex",
    width: "100%",
    flex: 1,
    overflowX: "auto",
    scrollSnapType: "x mandatory",
    WebkitOverflowScrolling: "touch",
  },
  slide: {
    flex: "0 0 100%",
    width: "100%",
    height: "100%",
    scrollSnapAlign: "start",
    display: "flex",
    flexDirection: "column",
    paddingTop: "20px",
    paddingBottom: "120px",
    overflowY: "auto",
    boxSizing: "border-box",
  },
  deskContent: {
    padding: "0 20px",
    maxWidth: "800px",
    width: "100%",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    boxSizing: "border-box",
  },
  greeting: {
    fontSize: "1.6rem",
    color: "#fff",
    fontWeight: "800",
    margin: "20px 0 10px",
    letterSpacing: "-0.5px",
  },
  subtext: { color: "rgba(255,255,255,0.5)", fontSize: "0.9rem", fontStyle: "normal" },
  glassSection: {
    background: "rgba(255, 255, 255, 0.05)",
    backdropFilter: "blur(20px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    padding: "20px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
    display: "flex",
    flexDirection: "column",
  },
  glassHeader: { display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" },
  glassTitle: {
    fontSize: "0.8rem",
    textTransform: "uppercase",
    letterSpacing: "2px",
    color: "#fff",
    opacity: 0.5,
    fontWeight: "bold",
    margin: 0,
  },
  glassCard: {
    background: "rgba(255, 255, 255, 0.05)",
    backdropFilter: "blur(20px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    padding: "20px",
    cursor: "pointer",
  },
  glassListItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px",
    background: "rgba(255,255,255,0.03)",
    borderRadius: "16px",
    cursor: "pointer",
  },
  glassTextarea: {
    flex: 1,
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "12px",
    padding: "12px",
    color: "#fff",
    fontSize: "0.95rem",
    outline: "none",
    minHeight: "80px",
    resize: "none",
    fontFamily: "inherit",
  },
  glassInputCompact: {
    flex: 1,
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "12px",
    padding: "12px",
    color: "#fff",
    fontSize: "0.95rem",
    outline: "none",
    minHeight: "44px",
    resize: "none",
    fontFamily: "inherit",
  },
  glassActionBtn: {
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s",
    background: "rgba(255,255,255,0.05)",
    color: "#fff",
  },
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "transparent",
    color: "#fff",
  },
  indicatorContainer: {
    position: "fixed",
    bottom: "100px",
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    zIndex: 100,
    pointerEvents: "auto",
  },
  indicatorBtn: {
    height: "6px",
    borderRadius: "3px",
    border: "none",
    padding: 0,
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  slideNavBtn: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "8px 14px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.06)",
    color: "#fff",
    cursor: "pointer",
    fontSize: "0.8rem",
    fontWeight: "600",
  },
  undoToast: {
    position: "fixed",
    bottom: "120px",
    left: "20px",
    right: "20px",
    background: "rgba(34, 197, 94, 0.95)",
    backdropFilter: "blur(12px)",
    padding: "12px 20px",
    borderRadius: "12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#fff",
    boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
    zIndex: 1100,
  },
  undoBtn: {
    background: "rgba(255,255,255,0.2)",
    border: "none",
    color: "#fff",
    padding: "6px 12px",
    borderRadius: "6px",
    fontSize: "0.75rem",
    fontWeight: "bold",
    cursor: "pointer",
  },
  viewToggle: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "12px",
    color: "#fff",
    cursor: "pointer",
    transition: "all 0.2s",
    fontSize: "0.85rem",
  },
  viewToggleActive: {
    background: "rgba(212,175,55,0.15)",
    borderColor: "rgba(212,175,55,0.4)",
    color: ACCENT,
  },
  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.6)",
    backdropFilter: "blur(8px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
    padding: "20px",
  },
  modalPanel: {
    background: "rgba(255, 255, 255, 0.05)",
    backdropFilter: "blur(20px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    padding: "24px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.4)",
    width: "100%",
    maxWidth: "480px",
  },
  pageContent: {
    padding: "20px",
    maxWidth: "900px",
    width: "100%",
    margin: "0 auto",
    boxSizing: "border-box",
  },
  glassRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "12px 14px",
    background: "rgba(255,255,255,0.03)",
    borderRadius: "14px",
    border: "1px solid rgba(255,255,255,0.08)",
    fontSize: "0.95rem",
    color: "#fff",
    lineHeight: 1.45,
  },
  glassPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 12px",
    borderRadius: "999px",
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.12)",
    color: "rgba(255,255,255,0.85)",
    fontSize: "0.78rem",
    cursor: "pointer",
  },
  glassPillActive: {
    background: "rgba(212,175,55,0.15)",
    borderColor: "rgba(212,175,55,0.45)",
    color: "#fff",
  },
  glassToolbar: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    padding: "0 16px",
    gap: "12px",
  },
  glassBottomBar: {
    height: "80px",
    background: "rgba(20, 20, 20, 0.6)",
    backdropFilter: "blur(24px)",
    borderTop: "1px solid rgba(255, 255, 255, 0.1)",
    flexShrink: 0,
    paddingBottom: "env(safe-area-inset-bottom)",
  },
  glassCanvas: {
    flex: 1,
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    background: "rgba(255,255,255,0.04)",
    borderRadius: "16px",
    border: "1px solid rgba(255,255,255,0.08)",
    margin: "0 16px",
  },
  glassChip: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "4px 10px",
    borderRadius: "20px",
    border: "1px solid rgba(255,255,255,0.1)",
    background: "rgba(255,255,255,0.03)",
    color: "rgba(255,255,255,0.5)",
    fontSize: "0.75rem",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "all 0.15s",
  },
  glassChipActive: {
    background: "rgba(212,175,55,0.15)",
    borderColor: "rgba(212,175,55,0.3)",
    color: ACCENT,
  },
  glassTag: {
    fontSize: "0.6rem",
    background: "rgba(212,175,55,0.08)",
    color: ACCENT,
    padding: "1px 6px",
    borderRadius: "10px",
    border: "1px solid rgba(212,175,55,0.15)",
  },
  readerPanel: {
    background: "rgba(255, 255, 255, 0.05)",
    backdropFilter: "blur(20px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    padding: "32px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.4)",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    overflow: "hidden",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  readerTitle: {
    color: "#fff",
    fontSize: "1.6rem",
    fontWeight: "800",
    margin: 0,
    letterSpacing: "-0.5px",
    fontFamily: "'Playfair Display', serif",
  },
  btnPrimary: {
    display: "flex",
    alignItems: "center",
    padding: "10px 24px",
    borderRadius: "12px",
    border: "1px solid rgba(212,175,55,0.4)",
    background: "rgba(212,175,55,0.1)",
    color: ACCENT,
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "0.9rem",
  },
  btnSecondary: {
    padding: "10px 24px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.1)",
    background: "rgba(255,255,255,0.05)",
    color: "rgba(255,255,255,0.7)",
    cursor: "pointer",
    fontSize: "0.9rem",
  },
  titleInput: {
    width: "100%",
    background: "transparent",
    border: "none",
    color: "#fff",
    fontSize: "1.2rem",
    fontWeight: "600",
    outline: "none",
    padding: "8px 0",
    fontFamily: "inherit",
  },
};

export default deskGlass;
